import { array, bool, string } from 'yup'

export const alertConfigSchema = {
  alertType: string(),
  active: bool(),
  externalContacts: array(),
  employeesIds: array()
}
